/* TestLoom - Mikro-A/B-Tests fuer naturmacher.de
 *
 * Grundsatz: Diese Datei darf den Shop unter keinen Umstaenden stoeren.
 * Jeder Schritt ist gekapselt; faellt irgendetwas aus, sieht der Besucher
 * die unveraenderte Originalseite. Gemeldet wird ausschliesslich per
 * sendBeacon, also ohne den Seitenaufbau aufzuhalten.
 */
/* TESTLOOM-VERSION: 2026-09-17-a */
(function () {
  'use strict';

  // Doppelladeschutz. Genau der Fehler, der bei GoAffPro seit Wochen
  // jede Fehlerstatistik verdirbt - hier still und ohne throw.
  if (window.__testloom) { return; }
  window.__testloom = true;

  var BASIS = 'https://workloom.de/testloom/';
  var SCHL_BESUCHER = 'tl_besucher';
  var SCHL_CACHE = 'tl_konfig';
  var CACHE_MS = 120000;      // 2 Minuten - begrenzt, wie lange
                            // ein abgeschalteter Test optisch nachwirkt
  // Zeitlimit fuer den Konfig-Abruf. Gemessen dauert er beim Seitenaufbau
  // rund 1 s, weil er mit ueber 300 anderen Requests konkurriert - der
  // Server selbst antwortet in ~50 ms. Mit 800 ms wurde JEDE Antwort
  // verworfen und nie ein Test ausgespielt. Das Limit schuetzt nur davor,
  // die Seite nach langem Warten noch umzubauen (sichtbarer Sprung);
  // die Seite selbst wartet ohnehin nicht, der Abruf laeuft nebenher.
  var ABRUF_MS = 3000;
  var lauf = [];              // aktive Tests dieser Seite

  /* ---------------------------------------------------------- Werkzeug */

  function sicher(fn, test) {
    try { return fn(); }
    catch (e) { fehlerMelden(test, e); return null; }
  }

  function lese(schluessel) {
    try { return window.localStorage.getItem(schluessel); } catch (e) { return null; }
  }
  function schreibe(schluessel, wert) {
    try { window.localStorage.setItem(schluessel, wert); } catch (e) { /* privater Modus */ }
  }

  function melde(pfad, daten) {
    try {
      var text = JSON.stringify(daten);
      // text/plain vermeidet den CORS-Preflight; der Server liest den Rumpf roh.
      if (navigator.sendBeacon) {
        navigator.sendBeacon(BASIS + pfad, new Blob([text], { type: 'text/plain' }));
      } else {
        fetch(BASIS + pfad, { method: 'POST', body: text, keepalive: true, mode: 'cors' });
      }
    } catch (e) { /* Messung darf nie stoeren */ }
  }

  function fehlerMelden(test, e) {
    try {
      melde('fehler/', { test: test || 'unbekannt', text: String((e && e.stack) || e).slice(0, 900) });
    } catch (x) { /* nichts */ }
  }

  // Ohne Einwilligung wird NICHTS dauerhaft gespeichert. Die Kennung
  // lebt dann nur fuer die Sitzung: die Zuteilung bleibt waehrend des
  // Besuchs stabil, aber der Besucher ist beim naechsten Mal ein neuer.
  // Folge: Sichten werden etwas ueberzaehlt, der Vergleich A gegen B
  // bleibt aber fair, weil beide Varianten gleich betroffen sind.
  function einwilligung() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      return !!(cp && typeof cp.analyticsProcessingAllowed === 'function'
                && cp.analyticsProcessingAllowed());
    } catch (e) { return false; }
  }

  function speicher() {
    // Im Zweifel das Fluechtige - auch wenn die Consent-API noch fehlt.
    try {
      return einwilligung() ? window.localStorage : window.sessionStorage;
    } catch (e) { return null; }
  }

  function besucherId() {
    var sp = speicher();
    var dauerhaft = (sp === window.localStorage);
    var v = null;
    try { v = sp && sp.getItem(SCHL_BESUCHER); } catch (e) { v = null; }
    if (v && /^[A-Za-z0-9]{6,64}$/.test(v)) { return v; }
    v = '';
    try {
      var a = new Uint8Array(12);
      (window.crypto || window.msCrypto).getRandomValues(a);
      for (var i = 0; i < a.length; i++) { v += (a[i] % 36).toString(36); }
    } catch (e) {
      v = (Date.now().toString(36) + Math.random().toString(36).slice(2, 10));
    }
    // Praefix haelt fest, woher die Kennung stammt: p = dauerhaft
    // (mit Einwilligung), s = nur fuer diese Sitzung.
    v = (dauerhaft ? 'p' : 's')
        + v.replace(/[^A-Za-z0-9]/g, '').slice(0, 22);
    try { if (sp) { sp.setItem(SCHL_BESUCHER, v); } } catch (e) { /* egal */ }
    return v;
  }

  // Stabile Zuteilung: derselbe Besucher sieht in demselben Test immer
  // dieselbe Variante, auch ohne gespeicherte Zuordnung.
  function variante(test, besucher) {
    var s = test + ':' + besucher, h = 5381;
    for (var i = 0; i < s.length; i++) { h = ((h << 5) + h + s.charCodeAt(i)) >>> 0; }
    return (h % 2) === 0 ? 'A' : 'B';
  }

  function geraet() {
    var b = window.innerWidth || 1024;
    return b < 768 ? 'mobil' : (b < 1024 ? 'tablet' : 'pc');
  }

  function pfadPasst(muster) {
    if (!muster || !muster.length) { return true; }
    var p = location.pathname;
    for (var i = 0; i < muster.length; i++) {
      if (muster[i] && p.indexOf(muster[i]) !== -1) { return true; }
    }
    return false;
  }

  /* ------------------------------------------------- Variante anwenden */

  function cssSetzen(test, text) {
    if (!text) { return; }
    var el = document.createElement('style');
    el.setAttribute('data-testloom', test);
    el.appendChild(document.createTextNode(text));
    (document.head || document.documentElement).appendChild(el);
  }

  // Kleine Hilfe fuer den haeufigsten Fall: ein Element existiert erst,
  // wenn das Theme es nachgeladen hat.
  function warteAuf(auswahl, dann, frist) {
    var ende = Date.now() + (frist || 8000);
    (function suche() {
      var el = null;
      try { el = document.querySelector(auswahl); } catch (e) { return; }
      if (el) { dann(el); return; }
      if (Date.now() < ende) { setTimeout(suche, 120); }
    })();
  }

  function jsAusfuehren(test, code) {
    if (!code || !code.trim()) { return; }
    // Der Code laeuft in einer eigenen Funktion, nicht im globalen Raum.
    // Er bekommt ein kleines Hilfsobjekt und kann nichts ueberschreiben.
    var hilfe = {
      test: test,
      // Wartet, bis Bilder UND Schriften geladen sind. Wichtig fuer alles,
      // was in ein <canvas> zeichnet: Der Browser nimmt dort die Schrift,
      // die im Moment des Zeichnens verfuegbar ist - zu frueh gezeichnet
      // ergibt eine Ersatzschrift, die nicht mehr korrigiert wird.
      // Gemessen auf naturmacher.de: fonts.status ist nach 2 s noch
      // 'loading' und erst nach rund 10 s 'loaded'.
      bereit: function (dann) {
        // NUR auf die Schriften warten, NICHT auf das load-Ereignis.
        // Gemessen auf naturmacher.de: fonts.ready ist nach ~3,3 s
        // erfuellt, load erst nach 16-18 s (alle Bilder). Wer auf load
        // wartet, zeichnet spaeter, als der Durchschnittsbesucher
        // ueberhaupt bleibt (~8 s).
        var notfall = setTimeout(function () { sicher(dann, test); }, 5000);
        try {
          if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
            document.fonts.ready.then(function () {
              clearTimeout(notfall);
              setTimeout(function () { sicher(dann, test); }, 60);
            });
            return;
          }
        } catch (e) { /* aeltere Browser: es bleibt beim Notfall-Zeitgeber */ }
      },
      warte: function (auswahl, dann) { warteAuf(auswahl, function (el) { sicher(function () { dann(el); }, test); }); },
      alle: function (auswahl) { try { return [].slice.call(document.querySelectorAll(auswahl)); } catch (e) { return []; } },
      text: function (auswahl, neu) { warteAuf(auswahl, function (el) { el.textContent = neu; }); },
      ereignis: function (name, kennung, wert) { ereignisMelden(test, name, kennung, wert); }
    };
    sicher(function () {
      var f = new Function('ab', code);
      f(hilfe);
    }, test);
  }

  /* ------------------------------------------------------- Messen */

  var gemeldet = {};

  function ereignisMelden(test, art, kennung, wert) {
    var s = lauf.filter(function (t) { return t.test === test; })[0];
    if (!s || s.vorschau) { return; }
    var schluessel = test + '|' + art + '|' + (kennung || '');
    if (art !== 'zeit' && gemeldet[schluessel]) { return; }
    gemeldet[schluessel] = true;
    melde('ereignis/', {
      test: test, variante: s.variante, besucher: s.besucher,
      art: art, kennung: String(kennung || '').slice(0, 60), wert: wert || 0,
      pruefung: s.pruefung
    });
  }

  function messenAufsetzen(s) {
    var marken = [25, 50, 75, 100], start = Date.now(), letzte = 0;
    // Zeitpunkt des ERSTEN Scrollens. Damit laesst sich die Zeit davor
    // (Orientierung: was ist das, lohnt sich das?) von der Zeit danach
    // (echtes Auseinandersetzen) trennen.
    var ersterScroll = null;

    function scroll() {
      var h = document.documentElement;
      var gesamt = (h.scrollHeight - h.clientHeight);
      if (gesamt <= 0) { return; }
      var anteil = Math.min(100, Math.round((h.scrollTop || window.pageYOffset) / gesamt * 100));
      for (var i = 0; i < marken.length; i++) {
        if (anteil >= marken[i]) { ereignisMelden(s.test, 'scroll', String(marken[i])); }
      }
    }
    window.addEventListener('scroll', function () {
      var jetzt = Date.now();
      if (ersterScroll === null) { ersterScroll = jetzt; }
      if (jetzt - letzte < 400) { return; }
      letzte = jetzt;
      sicher(scroll, s.test);
    }, { passive: true });

    // Klicks: alles mit data-ab-klick, plus die Warenkorb-Schaltflaeche.
    document.addEventListener('click', function (ev) {
      sicher(function () {
        var el = ev.target;
        for (var i = 0; el && i < 6; i++, el = el.parentElement) {
          if (el.getAttribute && el.getAttribute('data-ab-klick')) {
            ereignisMelden(s.test, 'klick',
              el.getAttribute('data-ab-klick').replace(/[^A-Za-z0-9_.:-]/g, '').slice(0, 60));
            return;
          }
          if (el.matches && (el.matches('[name="add"]')
              || el.matches('button[type="submit"][data-add-to-cart]')
              || (el.closest && el.closest('form[action*="/cart/add"]') && el.matches('button,input[type="submit"]')))) {
            ereignisMelden(s.test, 'warenkorb', '');
            return;
          }
        }
      }, s.test);
    }, true);

    // Bedienung des Konfigurators - MUSS im Snippet stehen, nicht im
    // Testcode: Der laeuft nur bei Variante B, gemessen werden muss aber
    // in beiden, sonst ist der Vergleich wertlos.
    // Gemeldet wird je Feldgruppe nur einmal (unique_together greift).
    function feldname(el) {
      var n = (el.name || el.id || '').replace(/[^A-Za-z0-9_.:-]/g, '');
      if (!n) { return ''; }
      // hz-motiv-7 -> hz-motiv, damit nicht 27 Einzelwerte entstehen
      return n.replace(/-\d+$/, '').slice(0, 60);
    }
    document.addEventListener('change', function (ev) {
      sicher(function () {
        var t = ev.target;
        if (!t || !t.tagName) { return; }
        // NUR echte Nutzeraktionen. Das Theme setzt die Variante rund 7 s
        // nach dem Laden selbst per Skript - das waere sonst als
        // "Ausfuehrung gewaehlt" gezaehlt worden (gemessen: 72-82 % statt
        // realistischer Werte).
        if (!ev.isTrusted) { return; }
        if (['INPUT', 'SELECT', 'TEXTAREA'].indexOf(t.tagName) === -1) { return; }
        var n = feldname(t);
        if (n) { ereignisMelden(s.test, 'klick', n); }
      }, s.test);
    }, true);
    // Texteingaben melden erst, wenn wirklich getippt wurde
    document.addEventListener('input', function (ev) {
      sicher(function () {
        var t = ev.target;
        if (!t || !t.tagName) { return; }
        if (!ev.isTrusted) { return; }
        if (t.tagName !== 'INPUT' && t.tagName !== 'TEXTAREA') { return; }
        if (!(t.value || '').trim()) { return; }
        var n = feldname(t);
        if (n) { ereignisMelden(s.test, 'klick', n); }
      }, s.test);
    }, true);

    // --- Bilder: wie lange war welches im Blick? ----------------------
    // Gemessen wird SICHTBARKEIT, nicht Blickkontakt - ein Bild kann im
    // Bild sein, ohne angesehen zu werden. Die Zahl ist ein Anhaltspunkt,
    // kein Beweis. Gemeldet wird erst ab 1 Sekunde, sonst entstuenden
    // Dutzende Zeilen fuer Bilder, an denen nur vorbeigescrollt wurde.
    var bildZeit = {}, bildStart = {};
    function bildKennung(el, nr) {
        var src = (el.currentSrc || el.src || '');
        var name = src.split('?')[0].split('/').pop()
                      .replace(/\.(jpg|jpeg|png|webp|avif|gif)$/i, '')
                      .replace(/_?[0-9a-f]{8}-[0-9a-f-]{20,}/i, '')   // UUID weg
                      .replace(/[^A-Za-z0-9_.:-]/g, '');
        return ('bild' + (nr < 10 ? '0' : '') + nr + '-' + name).slice(0, 58);
    }
    sicher(function () {
        if (!window.IntersectionObserver) { return; }
        var nr = 0;
        var beo = new IntersectionObserver(function (eintraege) {
            var jetzt = Date.now();
            eintraege.forEach(function (e) {
                var k = e.target.__tlk;
                if (!k) { return; }
                if (e.isIntersecting && e.intersectionRatio >= 0.5) {
                    if (!bildStart[k]) { bildStart[k] = jetzt; }
                } else if (bildStart[k]) {
                    bildZeit[k] = (bildZeit[k] || 0) + (jetzt - bildStart[k]);
                    bildStart[k] = null;
                }
            });
        }, { threshold: [0, 0.5] });
        // Erst nachdem das Theme die Galerie aufgebaut hat
        setTimeout(function () {
            sicher(function () {
                [].slice.call(document.querySelectorAll('img')).forEach(function (el) {
                    var r = el.getBoundingClientRect();
                    if (r.width < 120 || r.height < 120) { return; }   // Symbole raus
                    if (el.__tlk) { return; }
                    nr++;
                    el.__tlk = bildKennung(el, nr);
                    beo.observe(el);
                });
            }, s.test);
        }, 3500);
    }, s.test);

    function bilderMelden() {
        var jetzt = Date.now();
        Object.keys(bildStart).forEach(function (k) {
            if (bildStart[k]) {
                bildZeit[k] = (bildZeit[k] || 0) + (jetzt - bildStart[k]);
                bildStart[k] = null;
            }
        });
        Object.keys(bildZeit).forEach(function (k) {
            var sek = Math.round(bildZeit[k] / 1000);
            if (sek < 1 || sek > 86400) { return; }
            melde('ereignis/', {
                test: s.test, variante: s.variante, besucher: s.besucher,
                art: 'zeit', kennung: k, wert: sek, pruefung: s.pruefung
            });
        });
    }

    // Verweildauer: beim Verlassen melden, Wert wird serverseitig aktualisiert.
    function zeitMelden() {
      var jetzt = Date.now();
      var sek = Math.round((jetzt - start) / 1000);
      // Obergrenze 1 Stunde: laenger offene Tabs sind kein Interesse,
      // sondern ein vergessenes Fenster. Ein einziger 24-Stunden-Wert
      // hat den Mittelwert von 18 s auf 4826 s gezogen.
      if (sek > 0 && sek <= 3600) {
        melde('ereignis/', {
          test: s.test, variante: s.variante, besucher: s.besucher,
          art: 'zeit', kennung: 'gesamt', wert: sek, pruefung: s.pruefung
        });
      }
      // Nur bei Besuchern, die ueberhaupt gescrollt haben - sonst waere
      // "vor dem Scrollen" gleich der ganzen Sitzung und der Schnitt
      // waere nicht mehr vergleichbar.
      if (ersterScroll !== null) {
        var davor = Math.round((ersterScroll - start) / 1000);
        var danach = Math.round((jetzt - ersterScroll) / 1000);
        if (davor >= 0 && davor < 86400) {
          melde('ereignis/', {
            test: s.test, variante: s.variante, besucher: s.besucher,
            art: 'zeit', kennung: 'bis-scroll', wert: davor, pruefung: s.pruefung
          });
        }
        if (danach >= 0 && danach < 86400) {
          melde('ereignis/', {
            test: s.test, variante: s.variante, besucher: s.besucher,
            art: 'zeit', kennung: 'nach-scroll', wert: danach, pruefung: s.pruefung
          });
        }
      }
    }
    // pagehide/visibilitychange feuern nur bei rund 30 % der Besuche
    // (gemessen 17.09.2026). Deshalb zusaetzlich alle 20 s einen
    // Zwischenstand melden - der Server aktualisiert denselben Eintrag,
    // es entstehen also keine Doppelzaehlungen.
    var zwischen = setInterval(function () {
      sicher(function () {
        if (document.visibilityState === 'hidden') { return; }
        var sek = Math.round((Date.now() - start) / 1000);
        if (sek > 3600) { clearInterval(zwischen); return; }   // Tab vergessen
        zeitMelden();
      }, s.test);
    }, 20000);

    function abschluss() { clearInterval(zwischen); zeitMelden(); bilderMelden(); }
    window.addEventListener('pagehide', function () { sicher(abschluss, s.test); });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') { sicher(abschluss, s.test); }
    });
  }

  // Variante an den Warenkorb haengen - nur so taucht sie in der
  // Bestellung auf und die Kaeufe lassen sich zuordnen.
  function cartAttribut(s) {
    var merk = 'tl_cart_' + s.test;
    if (lese(merk) === s.variante) { return; }
    setTimeout(function () {
      sicher(function () {
        var d = {}; d[s.test] = s.variante;
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: d })
        }).then(function () { schreibe(merk, s.variante); })
          .catch(function () { /* Warenkorb unwichtig fuer die Messung */ });
      }, s.test);
    }, 2500);
  }

  /* ------------------------------------------------------- Ablauf */

  function starteTest(k) {
    if (!pfadPasst(k.pfade)) { return; }

    var besucher = besucherId();
    var erzwungen = null;
    try {
      var m = /[?&]ab=([AB])\b/.exec(location.search);
      if (m) { erzwungen = m[1]; }
    } catch (e) { /* nichts */ }

    var s = {
      test: k.test,
      variante: erzwungen || variante(k.test, besucher),
      besucher: besucher,
      vorschau: !!erzwungen,     // Vorschau wird NICHT gezaehlt
      pruefung: istPruefung()    // gezaehlt, aber als Pruefung markiert
    };
    lauf.push(s);

    if (s.variante === 'B') {
      cssSetzen(k.test, k.css);
      // NICHT auf DOMContentLoaded warten: Bei einer 630-KB-Seite tritt
      // das erst nach 5-9 s ein, obwohl die Elemente laengst im DOM sind
      // (gemessen: Konfigurator-Knopf nach 2,1 s). Der Testcode benutzt
      // ohnehin ab.warte(), das selbst auf sein Element wartet.
      jsAusfuehren(k.test, k.js);
    }

    if (s.vorschau) {
      try { console.info('[TestLoom] Vorschau ' + k.test + ' = ' + s.variante + ' (wird nicht gezaehlt)'); } catch (e) {}
      return;
    }

    melde('sicht/', {
      test: k.test, variante: s.variante, besucher: besucher,
      geraet: geraet(), pfad: location.pathname.slice(0, 200),
      pruefung: s.pruefung
    });
    messenAufsetzen(s);
    cartAttribut(s);
  }

  function anwenden(konfig) {
    if (!konfig || !konfig.tests) { return; }
    for (var i = 0; i < konfig.tests.length; i++) {
      var k = konfig.tests[i];
      sicher(function () { starteTest(k); }, k && k.test);
    }
  }

  // Eigener Pruefbesuch: mit ?tl_test=1 wird die Sicht zwar gemeldet,
  // aber als Pruefung markiert und aus jeder Auswertung herausgehalten.
  // So laesst sich der echte Ablauf testen, ohne die Zahlen zu faelschen
  // und ohne hinterher raten zu muessen, welcher Eintrag von wem stammt.
  function istPruefung() {
    try { return /[?&]tl_test=1\b/.test(location.search); } catch (e) { return false; }
  }

  function istVorschau() {
    try { return /[?&]ab=[AB]\b/.test(location.search); } catch (e) { return false; }
  }

  function holen() {
    // In der Vorschau immer frisch und inklusive Entwuerfen - sonst
    // muesste man einen Test live schalten, um ihn pruefen zu koennen.
    if (istVorschau()) {
      fetch(BASIS + 'konfig/?vorschau=1', { mode: 'cors', credentials: 'omit', cache: 'no-store' })
        .then(function (a) { return a.json(); })
        .then(function (d) { anwenden(d); })
        .catch(function () { /* Original zeigen */ });
      return;
    }

    // Zwischenspeicher zuerst: verhindert sichtbares Umbauen auf
    // Folgeseiten und spart einen Abruf.
    var roh = lese(SCHL_CACHE);
    if (roh) {
      try {
        var c = JSON.parse(roh);
        if (c && (Date.now() - c.zeit) < CACHE_MS) {
          anwenden(c.daten);
          return;                        // frisch genug
        }
      } catch (e) { /* kaputter Zwischenspeicher */ }
    }

    var fertig = false;
    var abbruch = setTimeout(function () { fertig = true; }, ABRUF_MS);

    fetch(BASIS + 'konfig/', { mode: 'cors', credentials: 'omit' })
      .then(function (a) { return a.json(); })
      .then(function (d) {
        clearTimeout(abbruch);
        schreibe(SCHL_CACHE, JSON.stringify({ zeit: Date.now(), daten: d }));
        if (!fertig) { anwenden(d); }     // nach der Frist: Original zeigen
      })
      .catch(function () { clearTimeout(abbruch); });
  }

  sicher(holen, null);
})();
